import { EncodedJSONAttribute, decodeJSONFromDataAttribute } from '../../../_common/encode-decode-json-for-data-attribute';
import { ReviewSubmissionClientData } from '../../types/review-submission-client-data';

export type GetReviewSubmissionClientDataParams = {
    rootElement: Pick<HTMLElement, 'dataset'>;
};
export const getReviewSubmissionClientData = ({ rootElement }: GetReviewSubmissionClientDataParams) => {
    const { reviewSubmissionClientDataStringifiedEncoded } = rootElement.dataset;
    if (reviewSubmissionClientDataStringifiedEncoded === undefined) throw new Error('Review Submission Client Data not found');
    return decodeJSONFromDataAttribute(reviewSubmissionClientDataStringifiedEncoded as EncodedJSONAttribute<ReviewSubmissionClientData>);
};
